const ALIAS_RULES: Array<{ terms: string[]; aliases: string[] }> = [
  { terms: ['key', 'keys', 'lock key', 'spare key'], aliases: ['chaabi', 'chabi', 'چابی', 'keychain', 'door key', 'lock opener'] },
  { terms: ['tape', 'packing tape', 'box tape'], aliases: ['adhesive roll', 'sticky tape', 'parcel tape', 'ٹیپ'] },
  { terms: ['flashlight', 'torch'], aliases: ['flaslight', 'torch light', 'emergency light', 'battery light'] },
  { terms: ['scissors', 'scissor'], aliases: ['cutter', 'paper cutter', 'قینچی'] },
  { terms: ['charger', 'charging cable', 'cable'], aliases: ['adapter', 'wire', 'usb cable', 'phone charger'] },
  { terms: ['remote', 'remote control'], aliases: ['tv remote', 'controller'] },
  { terms: ['medicine', 'pills', 'tablet'], aliases: ['meds', 'دوائی', 'dawai', 'first aid'] },
  { terms: ['battery', 'batteries'], aliases: ['cell', 'aa battery', 'aaa battery'] }
];

const NORMALIZED_ALIAS_RULES = ALIAS_RULES.map((rule) => ({ ...rule, terms: rule.terms.map(normalizeText) }));

export function normalizeText(value: string) {
  return value.toLocaleLowerCase().replace(/[^\p{L}\p{N}\s]/gu, ' ').replace(/\s+/g, ' ').trim();
}

export function localSemanticAliases(name: string, locationNote: string, locationGroup = '') {
  const source = normalizeText([name, locationNote, locationGroup].join(' '));
  const aliases = new Set<string>();

  for (const rule of NORMALIZED_ALIAS_RULES) {
    if (rule.terms.some((term) => source.includes(term))) {
      rule.aliases.forEach((alias) => aliases.add(alias));
    }
  }
  if (locationGroup) aliases.add(locationGroup);
  if (locationNote) aliases.add(locationNote);
  return [...aliases].slice(0, 24);
}

export function mergeTerms(...groups: Array<string[] | string | undefined>) {
  const seen = new Set<string>();
  const merged: string[] = [];
  for (const group of groups) {
    for (const value of Array.isArray(group) ? group : [group]) {
      const cleaned = value?.trim();
      const normalized = normalizeText(cleaned ?? '');
      if (!cleaned || !normalized || seen.has(normalized)) continue;
      seen.add(normalized);
      merged.push(cleaned);
    }
  }
  return merged;
}
